export const geomTypes = {
  point: "Точечный",
  multi_point: "Точечный",
  line_string: "Линейный",
  multi_line_string: "Линейный",
  polygon: "Площадной",
  multi_polygon: "Площадной"
};

export const geomTypesIcon = {
  point: "node",
  multi_point: "node",
  line_string: "line",
  multi_line_string: "line",
  polygon: "polygon",
  multi_polygon: "polygon"
};
